/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from 'react';
import { RootState, useAppDispatch, useAppSelector } from '../../store.model';
import {
  getControlUnitsActiveById,
  getControlUnitsVisibleById,
  getDeviceControlUnitsErrorById,
  getDeviceControlUnitsLoadingById,
} from '../selectors';
import { fetchDeviceControlUnits } from '../actions/thunks';

/**
 * Get and fetch control unit from specified device
 * @param deviceId
 * @returns [controlUnits, loading, error]
 * 
 * @usage
´´´ts
const [controlUnits, loading, error] = useControlUnitsById("UUUID_DEVICE")
´´´
 */
export function useControlUnitsById(
  deviceId: string,
  onError: (error: unknown) => unknown,
  onlyVisibleControlUnits = false
) {
  const controlUnitSelector = useMemo(
    () =>
      onlyVisibleControlUnits
        ? getControlUnitsVisibleById
        : getControlUnitsActiveById,
    [onlyVisibleControlUnits]
  );
  const controlUnits = useAppSelector((state: RootState) =>
    controlUnitSelector(state, { deviceId })
  );
  const loading = !!useAppSelector((state: RootState) =>
    getDeviceControlUnitsLoadingById(state, { deviceId })
  );
  const error = useAppSelector((state: RootState) =>
    getDeviceControlUnitsErrorById(state, { deviceId })
  );

  // initial fetch
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!controlUnits) {
      Promise.resolve(
        dispatch<any>(fetchDeviceControlUnits(deviceId)).unwrap()
      ).catch(onError);
    }
  }, [controlUnits, deviceId, dispatch]);
  return [controlUnits, loading, error] as const;
}
